import Component from '@glimmer/component';
import { t } from 'ember-intl';
import WChangePasswordForm from 'login/components/w-change-password-form';
import WLoginDialog from 'login/components/w-login-dialog';
import type { ApplicationModel } from 'login/routes/application';

export default class ChangePassword extends Component<{ Args: { model: ApplicationModel } }> {
  get action(): string {
    return `changePassword${window.location.search}`;
  }

  <template>
    <WLoginDialog
      @pageTitle={{t 'login.title.resetPassword'}}
      @dialogTitle={{@model.logonParams.serviceName}}
      @version={{@model.version}}
    >
      <WChangePasswordForm
        action={{this.action}}
        @loginActionPasswordText='login.resetPasswordText'
        @loginActionPasswordLabel='login.newPasswordLabel'
        @loginActionPasswordButton='login.changePasswordButton'
      />
    </WLoginDialog>
  </template>
}
